import { api } from "@/lib/api";

export const DOC_TYPES = [
  "Loi de Finances",
  "Budget de l'État",
  "Rapport Cour des Comptes",
  "Contrat d'Emprunt/Dette",
  "Code Pénal",
  "Loi Anticorruption",
  "Autre",
];

export async function createProject(payload) {
  const { data } = await api.post("/projects", payload);
  return data.data;
}

export async function listProjects() {
  const { data } = await api.get("/projects");
  return data.data;
}

export async function listDocuments(projectId) {
  const { data } = await api.get(`/projects/${projectId}/documents`);
  return data.data;
}

export async function getDocument(documentId) {
  const { data } = await api.get(`/documents/${documentId}`);
  return data.data;
}

export async function pollDocumentUntilReady(documentId, {
  intervalMs = 2500,
  maxAttempts = 96, // ~4 min
  onTick = null,
} = {}) {
  for (let i = 0; i < maxAttempts; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const doc = await getDocument(documentId);
    if (onTick) onTick(doc);
    if (doc?.status === "analyzed") return doc;
    if (doc?.status === "failed") {
      throw new Error(doc?.error || "Analyse du document échouée.");
    }
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, intervalMs));
  }
  throw new Error("L'analyse prend plus de temps que prévu. Réessayez plus tard.");
}

export async function uploadDocument({ projectId, file, docType, onUploadProgress }) {
  const form = new FormData();
  form.append("file", file);
  form.append("doc_type", docType);
  const { data } = await api.post(`/projects/${projectId}/documents`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    timeout: 180000, // upload itself must complete within 3 min
  });
  return data;
}

export async function patchExtractedData(documentId, patch) {
  const { data } = await api.patch(`/documents/${documentId}/data`, patch);
  return data.data;
}

export async function deleteDocument(documentId) {
  const { data } = await api.delete(`/documents/${documentId}`);
  return data;
}

export function formatBytes(n) {
  if (!n && n !== 0) return "—";
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} Ko`;
  return `${(n / (1024 * 1024)).toFixed(1)} Mo`;
}

export function formatNumber(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  try {
    return Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 2 });
  } catch {
    return String(n);
  }
}

export function confidenceBand(score) {
  if (score === null || score === undefined) {
    return { label: "—", color: "muted", pct: 0 };
  }
  const pct = Math.round(Math.max(0, Math.min(1, Number(score))) * 100);
  if (pct >= 85) return { label: "Fiabilité élevée", color: "green", pct };
  if (pct >= 60) return { label: "Fiabilité moyenne", color: "orange", pct };
  return { label: "Fiabilité faible", color: "red", pct };
}
